module.exports = __webpack_public_path__ + "img/nav-0-active.25822d7.png";